import React, { useEffect, useState } from 'react';
import Loader from '../../components/UI/loader';
import ErrorMessage from '../../components/errorMessage';
import { func } from 'prop-types';
import ItemsListView from '../../components/itemsListView';

const ItemsList = ({ renderItem, onItemSelected, getData }) => {

  const [itemList, setItemList] = useState(null)
  const [error, setErrorStatus] = useState(false)

  let _isMounted = false

  const onError = () => setErrorStatus(true)

  useEffect(() => {
    // eslint-disable-next-line 
    _isMounted = true
    getData()
      .then(data => {
        if (_isMounted) {
          setItemList(data)
        }
      })
      .catch(onError)

    return () => _isMounted = false
  }, [])

  if (error) {
    return <ErrorMessage />
  }

  if (!itemList) {
    return <Loader />
  }

  return <ItemsListView itemList={itemList} renderItem={renderItem} onItemSelected={onItemSelected} />
}

ItemsList.propTypes = {
  onItemSelected: func,
  renderItem: func,
  getData: func,
}

export default ItemsList